<template>
  <div class="container">
    <div class="content--wrapper">
      <h3>Completa los parámetros</h3>

      <CustomScrollbar height="430px" auto>
        <a-form
          v-if="parametersNumber"
          layout="vertical"
          class="form"
          ref="formRef"
          :model="formState"
        >
          <a-form-item
            v-for="idx in parametersNumber"
            :key="idx"
            :label="`Nombre del parámetro {{${idx}}}`"
            :name="idx"
            required
          >
            <a-input
              v-model:value="formState[idx]"
              placeholder="Ingrese el nombre"
              show-count
              :maxlength="50"
            />
          </a-form-item>
        </a-form>

        <span v-else class="info">
          Esta plantilla aún no cuenta con parámetros. Puedes agregarlos desde la sección
          “Contenido”.
        </span>
      </CustomScrollbar>
    </div>

    <SmsTemplatePhone :content="content" />
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref, toRaw, watch } from "vue";
import { FormInstance } from "ant-design-vue";
import { cloneDeep, isEqual } from "lodash";

import { ParametersFormState } from "@/@types/channels/sms/dto";
import { templateParamRegex } from "@/app/channels/utils/regex";
import { SmsTemplate } from "@/@types/channels/sms";

import SmsTemplatePhone from "@/app/channels/components/modals/sms/templates/SmsTemplatePhone.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

const props = defineProps<{ content: string; smsTemplate: SmsTemplate }>();

const emit = defineEmits<{ toggleButton: [disabled: boolean] }>();

const formRef = ref<FormInstance>();
const formState: ParametersFormState = reactive({});

const referenceFormState = cloneDeep(toRaw(formState));

watch(formState, () => {
  formRef.value
    ?.validate()
    .then(() => emit("toggleButton", isEqual(referenceFormState, formState)))
    .catch(() => emit("toggleButton", true));
});

const parametersNumber = computed(() => {
  const parametersInContent = props.content?.match(templateParamRegex);

  return parametersInContent?.length;
});

watch(
  parametersNumber,
  (number) => {
    if (!number) return;

    for (let i = 1; i <= number; i++) {
      formState[i] = props.smsTemplate?.parameters?.at(i - 1)?.name || "";
    }
  },
  { immediate: true }
);

defineExpose({ formState: { parameters: toRaw(formState) } });
</script>

<style scoped lang="sass">
.container
  display: flex
  gap: 30px
  align-items: flex-start

.content--wrapper
  min-width: 0

h3
  font-size: 24px
  font-weight: 600
  color: $gray-9
  margin-bottom: 4px
  line-height: 32px

p
  color: $gray-8
</style>
